import { render, staticRenderFns } from "./DeadlinesFilters.vue?vue&type=template&id=bd82b614"
import script from "./DeadlinesFilters.vue?vue&type=script&lang=js"
export * from "./DeadlinesFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports